import React, {Fragment} from 'react';
import FormRow from "v4/components/form/FormRender/components/FormRow/FormRow";
import {PolIcon} from "components/PolIcon/policon";
import useMapImportColumnFields
    from "v4/pages/admin/Import/components/ImportSteps/components/MapImport/components/MapImportColumnFields/hooks/useMapImportColumnFields";
import MapImportColumnFieldsConcatenationField
    from "v4/pages/admin/Import/components/ImportSteps/components/MapImport/components/MapImportColumnFields/components/MapImportColumnFieldsConcatenationField";
import {useFormRenderContext} from "v4/components/form/FormRender/context/FormRenderContext";

const associatedSuffixes = ['_action'];

export default function MapImportColumnFields({headerKey}) {
    const {getField} = useFormRenderContext();
    const {isMapped} = useMapImportColumnFields(headerKey);

    return (
        <div key={headerKey} className="map-import__column-fields">
            <PolIcon icon="return" className={`map-import__column-fields__icon ${isMapped ? '' : 'is-error'}`}/>

            <FormRow fieldName={headerKey}/>

            {associatedSuffixes.map(suffix => {
                const fieldName = `${headerKey}${suffix}`;

                const field = getField(fieldName);

                if (!field) return null;

                return (
                    <Fragment key={fieldName}>
                        <FormRow fieldName={fieldName}
                                 className="d-none"
                        />
                        <MapImportColumnFieldsConcatenationField fieldToUpdate={field}/>
                    </Fragment>
                );
            })}

        </div>
    )
}
